import { PlatformAccountBase } from "./platform-account-base";

export class RetentionCenterAccount extends PlatformAccountBase {
  id: number;
  email: string;
  password: string;
  givenName: string;
  familyName: string;
}
